<template>
  <div class="container-table-list" :class="{ 'right-read': $i18n.locale === 'ar' }">
    <!-- todo 页面样式已修改 -->
    <!-- <div class="title">
      <div class="ac">{{ $t('lang.wd.phAccount') }}</div>
      <div class="call">{{ $t('lang.dl.callTime') }}</div>
      <div class="gift">{{ $t('lang.mybean.gifts') }}</div>
      <div class="in">{{ $t('lang.dl.income') }}</div>
    </div>
    <div class="data">
      <div class="list" v-for="(item, index) in data" :key="index">
        <div class="avater ac">
          <img :src="item.avatar | imgPath" alt="" />
          <div class="num"><img v-if="item.locationFlag" :src="item.locationFlag | imgPath" alt="" />{{ item.presentId }}</div>
        </div>
        <div class="call">{{ formatSeconds(item.hostCallTimeSeconds) }}</div>
        <div class="gift">{{ item.hostGiftIncome }} <img :src="getMatchImg('beans')" alt="" /></div>
        <div v-if="type === 'week'" class="in">{{ item.weekIncome }} <img :src="getMatchImg('beans')" alt="" /></div>
        <div v-if="type === 'day'" class="in">{{ item.dailyIncome }} <img :src="getMatchImg('beans')" alt="" /></div>
      </div>
      <div v-if="data && !data.length" class="van-list__finished-text" style="margin-top: 150px;">{{ $t('lang.noMore') }}</div>
    </div> -->

    <!-- 代理中心v1.0样式 -->
    <div class="list-fields">
      <div class="field field1">{{ $t('lang.wd.phAccount') }}</div>
      <div class="field field2">
        {{ $t('lang.dl.income') }}
        <img :src="getMatchImg('beans')" />
      </div>
      <div class="field field3">
        {{ $t('lang.dl.commission') }}
        <img :src="getMatchImg('beans')" />
      </div>
    </div>

    <div class="list-fields" v-for="(item, index) in data" :key="item.index">
      <div class="bd-field field1 user-info">
        <div class="name-id">
          <div class="name-wrap">
            <span>{{ item.nickname }}</span>
            <img :src="item.locationFlag | imgPath" />
          </div>
          <div class="id-wrap" @click="handleCopy(item.presentId, $t('lang.msgCopySuccss'))">
            ID:{{ item.presentId }}
            <img src="@/views/P2_Page/Invite/images/copy-gray.png" alt="" />
          </div>
        </div>
      </div>
      <div class="bd-field field2">{{ type === 'week' ? item.weekIncome : item.dailyIncome }}</div>
      <div class="bd-field field3">{{ type === 'week' ? item.weekCommission : item.dailyCommission }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    type: 'week',
    data: {}
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
  watch: {},
  computed: {}
}
</script>
<style lang="scss" scoped>
// // 旧版样式
// .title {
//   height: 52px;
//   line-height: 52px;
//   display: flex;
//   align-content: center;
//   justify-content: space-between;

//   font-family: Inter;
//   font-weight: bold;
//   font-size: 12px;
//   color: #333333;
//   line-height: 16px;
//   text-align: left;
//   font-style: normal;

//   border-bottom: 1px solid #f2f2f8;
// }
// .ac,
// .in {
//   flex: 1;
//   text-align: center;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   > img {
//     width: 16px;
//     height: 16px;
//     margin-left: 4px;
//   }
// }
// .call,
// .gift {
//   width: 95px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
//   > img {
//     width: 16px;
//     height: 16px;
//     margin-left: 4px;
//   }
// }
// .data {
//   .list {
//     display: flex;
//     font-family: Inter;
//     font-weight: 400;
//     font-size: 14px;
//     color: #666666;
//     line-height: 20px;
//     font-style: normal;
//     > div {
//       height: 74px;
//       border-bottom: 1px solid #f2f2f8;
//     }
//   }
//   .avater {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     font-size: 11px;
//     color: #999999;
//     > img {
//       width: 30px;
//       height: 30px;
//       border-radius: 50%;
//       object-fit: cover;
//     }
//     .num {
//       display: flex;
//       align-items: center;

//       > img {
//         width: 15px;
//         height: 10px;
//         object-fit: cover;
//         margin-right: 2px;
//       }
//     }
//   }
// }

// // 旧版兼容阿语
// .right-read {
//   .container-table-list {
//     .data {
//       .list {
//         .avater {
//           .num {
//             img {
//               margin-left: 2px !important;
//               margin-right: 0 !important;
//             }
//           }
//         }
//         .in,
//         .gift {
//           img {
//             margin-left: 0 !important;
//             margin-right: 4px !important;
//           }
//         }
//       }
//     }
//   }
// }

// 代理中心v1.0样式
.container-table-list {
  width: 100%;
  min-height: 500px;
  padding: 0 16px;
  .list-fields {
    width: 100%;
    display: flex;
    padding: 0 12px;
    margin: 14px 0;
    .field {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 14px;
      color: #b2b2b2;
      text-align: center;
      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
    }
    .field1 {
      flex: 1;
    }
    .field2 {
      flex: 1;
    }
    .field3 {
      flex: 1;
    }

    .bd-field {
      min-height: 36px;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      text-align: center;
      &.field2 {
        line-height: 36px;
      }
      &.field3 {
        line-height: 36px;
      }
    }
    .user-info {
      display: flex;
      .name-id {
        text-align: left;
        padding-left: 10px;
        .name-wrap {
          max-width: 98px;
          font-size: 0;
          text-align: left;
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: left;
          span {
            max-width: 80px;
            font-family: RobotoFlex;
            font-weight: 400;
            font-size: 15px;
            color: #333333;
            text-align: left;
            overflow: hidden;
            white-space: nowrap;
          }
          img {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-left: 5px;
            margin-top: 2px;
          }
        }
        .id-wrap {
          display: inline-block;
          margin-top: 4px;
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 12px;
          color: #b2b2b2;
          text-align: left;
          position: relative;
          word-break: break-all;
          img {
            width: 12px;
            height: 12px;
            margin-left: 4px;
            position: absolute;
            top: 50%;
            right: -16px;
            margin-top: -6px;
          }
        }
      }
    }
  }
}
</style>
